// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"692":"view","768":"page"}[chunkId] + "." + {"692":"38c226c7","768":"4f9fd0f1"}[chunkId] + ".css";
};